import * as yup from "yup";

export default yup
  .string()
  .matches(/^\d\d\d\d$/, `The postcode must be 4 digits.`);
